interface Props {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: Props) {
  if (total <= 1) return null;

  const pages: (number | "...")[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  return (
    <nav className="flex items-center justify-center gap-2 mt-8 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="px-3 h-9 rounded-md border border-background-200 text-sm text-foreground-700 bg-background-50 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap flex items-center gap-1 transition-colors"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>
      {pages.map((p, i) =>
        p === "..." ? (
          <span key={`ellipsis-${i}`} className="px-2 text-foreground-400">
            ...
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`w-9 h-9 rounded-md text-sm whitespace-nowrap transition-colors ${
              p === current
                ? "bg-primary-500 text-background-50 font-semibold"
                : "border border-background-200 text-foreground-700 bg-background-50 hover:bg-background-100"
            }`}
          >
            {p}
          </button>
        ),
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="px-3 h-9 rounded-md border border-background-200 text-sm text-foreground-700 bg-background-50 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap flex items-center gap-1 transition-colors"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}